import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { ContextoAutenticacao } from '../../routes/ContextoAutenticação';
import HomeMonitor from '../../pages/homeMonitor/HomeMonitor';
import Home from '../../pages/home/Home';
import HomeCoordenador from '../../pages/homecoordenador/HomeCoordenador';

const RedirecionamentoInicial = () => {
    const { usuario, carregando } = useContext(ContextoAutenticacao);

    if (carregando) {
        return <div>Carregando...</div>;
    }

    if (!usuario) {
        return <Navigate to="/login" replace />;
    }

    switch (usuario.grupoDeUsuarioId) {
        case 3:
            return <HomeMonitor />;
        case 4:
            return <HomeCoordenador />;
        case 2:
            return <Home />;
        default:
            return <Navigate to="/notfound" replace />;
    }
};

export default RedirecionamentoInicial;
